import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetTransferFromEvaluator = createAsyncThunk(
  "GetTransferFromEvaluator/GetTransferFromEvaluator",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/TransferFromEvaluator",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TransferFromEvaluator = createSlice({
  name: "TransferFromEvaluator",
  initialState: {
    TransferFromEvaluator: [],
    loadingTransferFromEvaluator: false,
    errorTransferFromEvaluator: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetTransferFromEvaluator.pending, (state, action) => {
        state.loadingTransferFromEvaluator = true;
        state.TransferFromEvaluator = action.payload;
        state.errorTransferFromEvaluator = null;
      })
      .addCase(GetTransferFromEvaluator.fulfilled, (state, action) => {
        state.loadingTransferFromEvaluator = false;
        state.TransferFromEvaluator = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetTransferFromEvaluator.rejected, (state, action) => {
        state.loadingTransferFromEvaluator = false;
        state.errorTransferFromEvaluator = action.payload;
      });
  },
});

export default TransferFromEvaluator.reducer;
